export default {
    word1: "EBC 파이낸셜 그룹 | 믿을 수 있는 글로벌 라이선스 브로커",
    word2:
      "EBC 파이낸셜 그룹은 외환, 주식, 지수, 원자재 등 다양한 자산 거래를 안전하고 전문적으로 지원하는 세계적인 금융 파트너입니다.",
    word3: "글로벌 베스트 거래 플랫폼",
    word4: `<span class="subtitle-20_medium md-body-14_medium">100</span>개국 이상 트레이더들이 신뢰하는 거래 플랫폼`,
    word5: "최대 레버리지",
    word6: "인기 종목",
    word7: "최저 스프레드",
    word8: `EBC, 유엔재단과 함께<br class="pc"/>말라리아 퇴치에 앞장섭니다`,
    word9: "EBC 카피트레이딩 커뮤니티상위 트레이더의 전략, 원클릭으로 복사하기",
    word10:
      "상위 트레이더의 거래 시그널을 무료로 복사하고,\n팔로워가 거래를 복사할 때 연 최대 18% 성과 보수를 얻으세요.",
    word11: "투명한 거래 환경",
    word12: "원클릭 카피 트레이딩",
    word13: "최대 연 18% 리워드",
    word14: "실시간 포지션 확인",
    word15: `EBC × 옥스퍼드대학교 <br class="pc"/>지속가능성 공동 세미나 개최`,
    word16: "지속 가능한 미래를 위한 글로벌 공동 연구와 대화",
    word17: "거래 시작하기",
    word18: "더 알아보기",
    word19: "글로벌 자산 투자의 시작, EBC",
    word20:
      "200여 종의 다양한 상품을 안정적인 유동성과 유리한 스프레드로 거래해, 더욱 뛰어난 투자 경험을 제공합니다.",
    word21: "외환 거래",
    word22: "귀금속·에너지 ",
    word23: "주가 지수",
    word24: "미국 주식",
    word25: "ETF",
    word26: "거래 상품",
    word27: "매도호가",
    word28: "매수호가",
    word29: "스프레드",
    word30: "레버리지",
    word31: "더 알아보기",
    word32: "87.6% 이상의 주문이 더 나은 가격으로 체결됩니다",
    word33:
      "EBC의 유동성 통합 시스템은 가격, 속도, 일관성에서 기존 거래 방식을 능가합니다.",
    word34: "초당 주문 처리량",
    word35: "평균 체결 속도",
    word36: "데이터 전송 안정성",
    word37: "최저 스프레드",
    word38: "EBC의 주문 최적화율은 업계 상위 2.5% 수준에 있습니다.",
    word39: "거래 시작하기",
    word40: "전 세계가 인정한 안전한 거래 경험",
    word41: "최고 수준의 규제와 보호 체계, 모든 거래에 신뢰를 더합니다.",
    word42: "안심할 수 있는 보호 체계",
    word43:
      "EBC는 고객 자금 보호를 최우선으로 합니다.\n영국 및 케이맨 법인의 고객 자금은 바클레이즈 은행의 기업 계좌에 분리 보관됩니다. \n\n또한 FCA, CIMA, ASIC 규제 요건을 엄격히 준수하며,영국 로이즈(Lloyd’s)의 전문 보험까지 더해 완벽한 자금 보호 체계를 제공합니다.",
    word44: "EBC 글로벌 파트너십",
    word45:
      "25개 이상의 국제 은행 및 금융기관과 협력하여 기관급 유동성과 0.0pip 스프레드를 제공합니다. \n\n또한 옥스퍼드대학교, 유엔재단 등과 함께 지속 가능한 미래를 위한 CSR 활동을 이어갑니다.",
    word46: "글로벌 최상위 규제",
    word47: "영국 FCA 규제",
    word48: "EBC Financial Group (UK) Ltd는",
    word49: "영국 금융행위감독청(FCA)의 인가 및 규제를 받고 있습니다.",
    word50: "라이선스 번호: 927552",
    word51: "케이맨제도 CIMA 규제",
    word52: "EBC Financial Group (Cayman) Ltd는",
    word53: "케이맨제도 통화청(CIMA)의 인가 및 규제를 받고 있습니다.",
    word54: "라이선스 번호: 2038223",
    word55: "호주 ASIC 규제",
    word56: "EBC Financial Group (Australia) Pty Ltd는",
    word57: "호주 증권투자위원회(ASIC)의 인가 및 규제를 받고 있습니다.",
    word58: "라이선스 번호: 500991",
    word59:
      "EBC 파이낸셜 그룹 산하 자회사들은 각 관할 지역의 엄격한 규제를 준수하며, 최고 수준의 인가를 보유하고 있습니다.",
    word60:
      "당사는 고객 자산의 안전을 최우선으로 하고, 글로벌 주요 금융기관과 협력해 업계를 선도하는 리스크 관리 체계를 운영합니다.",
    word61: "안전·투명성·신뢰, EBC가 지켜가는 핵심 원칙입니다.",
    word62: "글로벌 네트워크, 현지 밀착 지원",
    word63: "어디서든 누릴 수 있는 맞춤형 전문 금융 서비스",
    word64: "월간 거래량(USD)",
    word65: "등록 사용자 수(2025년 8월 기준)",
    word66: "거래 주문 최적화 성과(2025년 2분기)",
    word67: "서비스 제공 국가 수",
    word68: "문의하기",
    word69: "한국 로컬팀",
    word70: "EBC 뉴스",
    word71: "최신 소식, 금융 이슈, 전문가의 인사이트를 확인하세요.",
    word72: "뉴스",
    word73: "파트너",
    word74: "상담 신청하기",
    word75: "전담 매니저가 직접 연락드립니다.",
    word76: "제출하기",
    word77: "lots",
    word78: "pips",
    word79: "Others",
    word80: "글로벌 Top 10 인기 브로커",
    word81: "가장 투명한 브로커",
    word82: "최고 평점 브로커",
    word83: "최우수 주문 체결 브로커",
    word84: "글로벌 최우수 트레이딩 경험상",
    word85: "가장 신뢰받는 브로커",
    word86: "베스트 CFD 브로커",
    word87: "글로벌 베스트 ECN 브로커",
    word88: "글로벌 신예 브로커",
    word89: "베스트 CFD 제공사",
    word90: "베스트 FX 트레이딩 플랫폼",
    word91: "최우수 거래 체결",
    word92: "베스트 거래 플랫폼",
    word93: "이름/닉네임",
    word94: "이메일",
    word95: "휴대폰 번호",
    word96: "인증 코드",

};
